export const CHANGE_TOUR_ANCHOR_ATTRIBUTE = 'data-change-tour-anchor';

export function changeTourAnchor(tourKey: string, stepId: string) {
  return `${tourKey}:${stepId}`;
}

export function changeTourAnchorProps(tourKey: string, stepId: string) {
  return { [CHANGE_TOUR_ANCHOR_ATTRIBUTE]: changeTourAnchor(tourKey, stepId) };
}

export function findAnchor(tourKey: string, stepId: string) {
  return document.querySelector(`[${CHANGE_TOUR_ANCHOR_ATTRIBUTE}="${CSS.escape(changeTourAnchor(tourKey, stepId))}"]`);
}
